import '@polymer/polymer/polymer-legacy.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
Polymer({
  _template: html``,

  /*
    fires toast, prompt, cancel-prompt, secondary-prompt, cancel-secondary-prompt, tertiary-prompt, cancel-tertiary-prompt, zoom-to-active
  */
  is: 'select-ref-layer',

  properties: {
    activeCommand: {
      type: String,
      notify: true
    },
    activeItem: {
      type: String,
      notify: true
    },
    color: {
      type: String,
      value: '#999'
    },
    icon: {
      type: String,
      value: 'arrow-forward'
    },
    connsToLabel: {
      type: Array,
      notify: true
    },
    pointerAsCrosshair: {
      type: Boolean,
      value: false,
      notify: true
    },
    recordNodeMoveAttribute: String
  },

  init: function (button) {
    this.set('connsToLabel', []);
    this.activeCommand = 'select';
    this.fire('prompt', {
      text: 'Select Reference Layer'
    });
    this.fire('cancel-secondary-prompt');
    this.fire('cancel-tertiary-prompt');
  },

  map_pan: function (latitude, longitude, closest) {},

  select: function (closest, latitude, longitude, detail) {
    this.dispatchEvent(new CustomEvent('ref-select', { detail: { lat: latitude, lng: longitude }, bubbles: true, composed: true }));
    // on select, see if the dropper is on a reference layer
    // then pose two options
  },

  action_secondary: function () {},

  action_tertiary: function () {},

  getByKey: function (type, id) {
    return this.domHost.$[type].child(id);
  }
});
